import { render } from "./TagSelect.vue?vue&type=template&id=9457fac0&scoped=true"
import script from "./TagSelect.vue?vue&type=script&lang=js"
export * from "./TagSelect.vue?vue&type=script&lang=js"

import "./TagSelect.vue?vue&type=style&index=0&id=9457fac0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9457fac0"]])

export default __exports__